const topics = [
  { tag: '最新电视剧', heat: '9.8万', desc: '热播剧集每日更新', icon: 'ri-tv-2-line', color: 'bg-primary-100 text-primary-700' },
  { tag: '热门电影', heat: '8.5万', desc: '院线大片一网打尽', icon: 'ri-film-line', color: 'bg-accent-100 text-accent-700' },
  { tag: '综艺娱乐', heat: '7.2万', desc: '搞笑综艺笑不停', icon: 'ri-emotion-laugh-line', color: 'bg-secondary-100 text-secondary-700' },
  { tag: '动漫番剧', heat: '6.9万', desc: '热门动漫连载更新', icon: 'ri-ghost-line', color: 'bg-primary-100 text-primary-700' },
  { tag: '纪录片', heat: '4.3万', desc: '深度纪实探索世界', icon: 'ri-earth-line', color: 'bg-accent-100 text-accent-700' },
  { tag: '短剧精选', heat: '3.8万', desc: '精彩短剧一口气看完', icon: 'ri-flashlight-line', color: 'bg-secondary-100 text-secondary-700' },
  { tag: '红桃专区', heat: '10.2万', desc: '红桃视频热门内容', icon: 'ri-heart-pulse-line', color: 'bg-primary-100 text-primary-700' },
  { tag: '樱花专区', heat: '9.1万', desc: '樱花视频精选推荐', icon: 'ri-flower-line', color: 'bg-accent-100 text-accent-700' },
  { tag: '糖豆专区', heat: '5.6万', desc: '糖豆视频精彩合集', icon: 'ri-cake-line', color: 'bg-secondary-100 text-secondary-700' },
  { tag: '动作大片', heat: '7.8万', desc: '劲爆动作燃到炸裂', icon: 'ri-rocket-2-line', color: 'bg-primary-100 text-primary-700' },
  { tag: '悬疑烧脑', heat: '6.1万', desc: '高智商剧情反转', icon: 'ri-question-answer-line', color: 'bg-accent-100 text-accent-700' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="text-xs font-semibold text-primary-600 uppercase tracking-wider">热门话题</span>
          <h2 className="mt-2 text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            热门话题
          </h2>
          <p className="mt-2 text-sm text-foreground-500">追踪最新影视热点，发现全网热门讨论</p>
        </div>

        <div className="flex flex-wrap gap-3 justify-center">
          {topics.map((item) => (
            <a
              key={item.tag}
              href="#index"
              className={`group inline-flex items-center gap-2.5 px-5 py-3 rounded-xl ${item.color} transition-all duration-200 hover:scale-105 cursor-pointer`}
            >
              <div className="w-8 h-8 rounded-lg bg-white/60 flex items-center justify-center">
                <i className={`${item.icon} text-sm`}></i>
              </div>
              <div className="text-left">
                <div className="flex items-center gap-2">
                  <span className="text-sm font-semibold whitespace-nowrap">{item.tag}</span>
                  <span className="text-xs opacity-70 whitespace-nowrap">{item.heat}</span>
                </div>
                <p className="text-xs opacity-60 whitespace-nowrap">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}